import { Routes } from 'react-router-dom';
import { getRelayerRegistrationRoutes } from './modules/relayer-registration';
import { ErrorBoundary } from './components/ErrorBoundary';

const App = () => {
  return (
    <ErrorBoundary>
      <Routes>{getRelayerRegistrationRoutes()}</Routes>
    </ErrorBoundary>
  );
};

export default App;
